import { ITranslatedLocale } from '@/types/components/locale';

export const translatedDates: ITranslatedLocale[] = [
  { locale: 'af', language: 'Afrikaans', today: 'Vandag', tomorrow: 'Môre' },
  { locale: 'sq', language: 'Albanian', today: 'Sot', tomorrow: 'Nesër' },
  { locale: 'ar', language: 'Arabic', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-dz', language: 'Arabic (Algeria)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-kw', language: 'Arabic (Kuwait)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-ly', language: 'Arabic (Lybia)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-ma', language: 'Arabic (Morocco)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-sa', language: 'Arabic (Saudi Arabia)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'ar-tn', language: 'Arabic (Tunisia)', today: 'اليوم', tomorrow: 'غدًا' },
  { locale: 'hy-am', language: 'Armenian', today: 'Այսօր', tomorrow: 'Վաղը' },
  { locale: 'az', language: 'Azerbaijani', today: 'Bu gün', tomorrow: 'Sabah' },
  { locale: 'bm', language: 'Bambara', today: 'Bi', tomorrow: 'Sini' },
  { locale: 'eu', language: 'Basque', today: 'Gaur', tomorrow: 'Bihar' },
  { locale: 'be', language: 'Balarusion', today: 'Сёння', tomorrow: 'Заўтра' },
  { locale: 'bn', language: 'Bengali', today: 'আজ', tomorrow: 'আগামীকাল' },
  { locale: 'bs', language: 'Bosnian', today: 'Danas', tomorrow: 'Sutra' },
  { locale: 'br', language: 'Breton', today: 'Hiziv', tomorrow: "Warc'hoazh" },
  { locale: 'bg', language: 'Bulgarian', today: 'Днес', tomorrow: 'Утре' },
  { locale: 'my', language: 'Burmese', today: 'ယနေ့', tomorrow: 'မနက်ဖြန်' },
  { locale: 'km', language: 'Cambodian', today: 'ថ្ងៃនេះ', tomorrow: 'ថ្ងៃស្អែក' },
  { locale: 'ca', language: 'Catalan', today: 'Avui', tomorrow: 'Demà' },
  { locale: 'tzm', language: 'Central Atlas Tamazight', today: 'ⴰⵙⵙⴰ', tomorrow: 'ⴰⴽⴽⴰ' },
  { locale: 'tzm-latn', language: 'Central Atlas Tamazight Latin', today: 'Assa', tomorrow: 'Akka' },
  { locale: 'zh-cn', language: 'Chinese (China)', today: '今天', tomorrow: '明天' },
  { locale: 'zh-hk', language: 'Chinese (Hong Kong)', today: '今天', tomorrow: '明天' },
  { locale: 'zh-tw', language: 'Chinese (Taiwan)', today: '今天', tomorrow: '明天' },
  { locale: 'cv', language: 'Chuvash', today: 'Пӑн', tomorrow: 'Кӑрсаҫ' },
  { locale: 'hr', language: 'Croatian', today: 'Danas', tomorrow: 'Sutra' },
  { locale: 'cs', language: 'Czech', today: 'Dnes', tomorrow: 'Zítra' },
  { locale: 'da', language: 'Danish', today: 'I dag', tomorrow: 'I morgen' },
  { locale: 'nl', language: 'Dutch', today: 'Vandaag', tomorrow: 'Morgen' },
  { locale: 'nl-be', language: 'Dutch (Belgium)', today: 'Vandaag', tomorrow: 'Morgen' },
  { locale: 'en-au', language: 'English (Australia)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en-ca', language: 'English (Canada)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en-ie', language: 'English (Ireland)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en-il', language: 'English (Israel)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en-nz', language: 'English (New Zealand)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en-gb', language: 'English (United Kingdom)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'en', language: 'English (United States)', today: 'Today', tomorrow: 'Tomorrow' },
  { locale: 'eo', language: 'Esperanto', today: 'Hodiaŭ', tomorrow: 'Morgaŭ' },
  { locale: 'et', language: 'Estonian', today: 'Täna', tomorrow: 'Homme' },
  { locale: 'fo', language: 'Faroese', today: 'Í dag', tomorrow: 'Í morgin' },
  { locale: 'fi', language: 'Finnish', today: 'Tänään', tomorrow: 'Huomenna' },
  { locale: 'fr', language: 'French', today: "Aujourd'hui", tomorrow: 'Demain' },
  { locale: 'fr-ca', language: 'French (Canada)', today: "Aujourd'hui", tomorrow: 'Demain' },
  { locale: 'fr-ch', language: 'French (Switzerland)', today: "Aujourd'hui", tomorrow: 'Demain' },
  { locale: 'fy', language: 'Frisian', today: 'Hjoed', tomorrow: 'Moarn' },
  { locale: 'gl', language: 'Galician', today: 'Hoxe', tomorrow: 'Mañá' },
  { locale: 'ka', language: 'Georgian', today: 'დღეს', tomorrow: 'ხვალ' },
  { locale: 'de', language: 'German', today: 'Heute', tomorrow: 'Morgen' },
  { locale: 'de-at', language: 'German (Austria)', today: 'Heute', tomorrow: 'Morgen' },
  { locale: 'de-ch', language: 'German (Switzerland)', today: 'Heute', tomorrow: 'Morgen' },
  { locale: 'el', language: 'Greek', today: 'Σήμερα', tomorrow: 'Αύριο' },
  { locale: 'gu', language: 'Gujarati', today: 'આજે', tomorrow: 'કાલે' },
  { locale: 'he', language: 'Hebrew', today: 'היום', tomorrow: 'מחר' },
  { locale: 'hi', language: 'Hindi', today: 'आज', tomorrow: 'कल' },
  { locale: 'hu', language: 'Hungarian', today: 'Ma', tomorrow: 'Holnap' },
  { locale: 'is', language: 'Icelandic', today: 'Í dag', tomorrow: 'Á morgun' },
  { locale: 'id', language: 'Indonesian', today: 'Hari ini', tomorrow: 'Besok' },
  { locale: 'ga', language: 'Irish or Irish Gaelic', today: 'Inniu', tomorrow: 'Amárach' },
  { locale: 'it', language: 'Italian', today: 'Oggi', tomorrow: 'Domani' },
  { locale: 'it-ch', language: 'Italian (Switzerland)', today: 'Oggi', tomorrow: 'Domani' },
  { locale: 'ja', language: 'Japanese', today: '今日', tomorrow: '明日' },
  { locale: 'jv', language: 'Javanese', today: 'Saiki', tomorrow: 'Sesuk' },
  { locale: 'kn', language: 'Kannada', today: 'ಇಂದು', tomorrow: 'ನಾಳೆ' },
  { locale: 'kk', language: 'Kazakh', today: 'Бүгін', tomorrow: 'Ертең' },
  { locale: 'tlh', language: 'Klingon', today: 'DaHjaj', tomorrow: "wa'leS" },
  { locale: 'gom-latn', language: 'Konkani Latin script', today: 'आज', tomorrow: 'उद्याचे' },
  { locale: 'ko', language: 'Korean', today: '오늘', tomorrow: '내일' },
  { locale: 'ku', language: 'Kurdish', today: 'ئەمڕۆ', tomorrow: 'بەیانی' },
  { locale: 'ky', language: 'Kyrgyz', today: 'Бүгүн', tomorrow: 'Эртең' },
  { locale: 'lo', language: 'Lao', today: 'ມື້ນີ້', tomorrow: 'ມື້ອື່ນ' },
  { locale: 'lv', language: 'Latvian', today: 'Šodien', tomorrow: 'Rīt' },
  { locale: 'lt', language: 'Lithuanian', today: 'Šiandien', tomorrow: 'Rytoj' },
  { locale: 'lb', language: 'Luxembourgish', today: 'Haut', tomorrow: 'Muer' },
  { locale: 'mk', language: 'Macedonian', today: 'Денес', tomorrow: 'Утре' },
  { locale: 'ms', language: 'Malay', today: 'Hari ini', tomorrow: 'Esok' },
  { locale: 'ml', language: 'Malayalam', today: 'ഇന്ന്', tomorrow: 'നാളെ' },
  { locale: 'dv', language: 'Maldivian', today: 'މިއަދު', tomorrow: 'މިއަދު' },
  { locale: 'mt', language: 'Maltese (Malta)', today: 'Illum', tomorrow: 'Għada' },
  { locale: 'mi', language: 'Maori', today: 'Tēnei rā', tomorrow: 'Āpōpō' },
  { locale: 'mr', language: 'Marathi', today: 'आज', tomorrow: 'उद्या' },
  { locale: 'mn', language: 'Mongolian', today: 'Өнөөдөр', tomorrow: 'Маргааш' },
  { locale: 'me', language: 'Montenegrin', today: 'Данас', tomorrow: 'Сутра' },
  { locale: 'ne', language: 'Nepalese', today: 'आज', tomorrow: 'भोलि' },
  { locale: 'se', language: 'Northern Sami', today: 'Dán', tomorrow: 'Bijá' },
  { locale: 'nb', language: 'Norwegian Bokmål', today: 'I dag', tomorrow: 'I morgen' },
  { locale: 'nn', language: 'Nynorsk', today: 'I dag', tomorrow: 'I morgon' },
  { locale: 'fa', language: 'Persian', today: 'امروز', tomorrow: 'فردا' },
  { locale: 'pl', language: 'Polish', today: 'Dzisiaj', tomorrow: 'Jutro' },
  { locale: 'pt', language: 'Portuguese', today: 'Hoje', tomorrow: 'Amanhã' },
  { locale: 'pt-br', language: 'Portuguese (Brazil)', today: 'Hoje', tomorrow: 'Amanhã' },
  { locale: 'x-pseudo', language: 'Pseudo', today: 'Pseudo', tomorrow: 'Pseudo' },
  { locale: 'pa-in', language: 'Punjabi', today: 'ਅੱਜ', tomorrow: 'ਕਲ' },
  { locale: 'ro', language: 'Romanian', today: 'Astăzi', tomorrow: 'Mâine' },
  { locale: 'ru', language: 'Russian', today: 'Сегодня', tomorrow: 'Завтра' },
  { locale: 'gd', language: 'Scottish Gealic', today: 'An-diugh', tomorrow: 'A-màireach' },
  { locale: 'sr', language: 'Serbian', today: 'Данас', tomorrow: 'Сутра' },
  { locale: 'sr-cyrl', language: 'Serbian Cyrillic', today: 'Данас', tomorrow: 'Сутра' },
  { locale: 'sd', language: 'Sindhi', today: 'آڄو', tomorrow: 'سنڌي' },
  { locale: 'si', language: 'Sinhalese', today: 'අද', tomorrow: 'හෙට' },
  { locale: 'sk', language: 'Slovak', today: 'Dnes', tomorrow: 'Zajtra' },
  { locale: 'sl', language: 'Slovenian', today: 'Danes', tomorrow: 'Jutri' },
  { locale: 'es', language: 'Spanish', today: 'Hoy', tomorrow: 'Mañana' },
  { locale: 'es-do', language: 'Spanish (Dominican Republic)', today: 'Hoy', tomorrow: 'Mañana' },
  { locale: 'es-us', language: 'Spanish (United States)', today: 'Hoy', tomorrow: 'Mañana' },
  { locale: 'sw', language: 'Swahili', today: 'Leo', tomorrow: 'Kesho' },
  { locale: 'sv', language: 'Swedish', today: 'Idag', tomorrow: 'Imorgon' },
  { locale: 'tl-ph', language: 'Tagalog (Philippines)', today: 'Ngayon', tomorrow: 'Bukas' },
  { locale: 'tg', language: 'Tajik', today: 'Имрӯз', tomorrow: 'Пагоҳ' },
  { locale: 'tzl', language: 'Talossan', today: 'Uei', tomorrow: 'Mach' },
  { locale: 'ta', language: 'Tamil', today: 'இன்று', tomorrow: 'நாளை' },
  { locale: 'te', language: 'Telugu', today: 'ఈ రోజు', tomorrow: 'రేపు' },
  { locale: 'tet', language: 'Tetun Dili (East Timor)', today: 'Ohin', tomorrow: 'Aban' },
  { locale: 'th', language: 'Thai', today: 'วันนี้', tomorrow: 'พรุ่งนี้' },
  { locale: 'bo', language: 'Tibetan', today: 'ད་རེས་དེ་རང་སྐྱོང་།', tomorrow: 'ནང་དང་རང་སྐྱོང་།' },
  { locale: 'tr', language: 'Turkish', today: 'Bugün', tomorrow: 'Yarın' },
  { locale: 'uk', language: 'Ukrainian', today: 'Сьогодні', tomorrow: 'Завтра' },
  { locale: 'ur', language: 'Urdu', today: 'آج', tomorrow: 'کل' },
  { locale: 'ug-cn', language: 'Uyghur (China)', today: 'بۈگۈن', tomorrow: 'ئەتە' },
  { locale: 'uz', language: 'Uzbek', today: 'Бугун', tomorrow: 'Эртага' },
  { locale: 'uz-latn', language: 'Uzbek Latin', today: 'Bugun', tomorrow: 'Ertaga' },
  { locale: 'vi', language: 'Vietnamese', today: 'Hôm nay', tomorrow: 'Ngày mai' },
  { locale: 'cy', language: 'Welsh', today: 'Heddiw', tomorrow: 'Yfory' },
  { locale: 'yo', language: 'Yoruba Nigeria', today: 'Owọ́́n', tomorrow: 'Ọ̀la' },
  { locale: 'ss', language: 'siSwati', today: 'Namuhla', tomorrow: 'Kusasa' },
];

export const LIST_LOCALE_NOT_SUPPORT = [
  'ar-kw',
  'ar-ma',
  'ar-sa',
  'tzm',
  'ckb',
  'zh-cn',
  'zh-hk',
  'zh-tw',
  'kw',
  'nl-be',
  'en-au',
  'en-ca',
  'en-ie',
  'en-nz',
  'en-gb',
  'fil',
  'fr-ca',
  'fr-ch',
  'de-at',
  'de-ch',
  'ia',
  'it-ch',
  'ks',
  'ki',
  'lu',
  'nd',
  'nn',
  'pt-br',
  'pt-pt',
  'rm',
  'sc',
  'ii',
  'es-do',
  'es-us',
];
